import { useNeighboringAlarms } from '@hakimo-ui/hakimo/data-access';
import { DataVersion, ReducedAlarm } from '@hakimo-ui/hakimo/types';
import { QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { TableData } from '@hakimo-ui/hakimo/ui-table';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ReactElement, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { appendVersionParam } from '@hakimo-ui/hakimo/util';
import { getTableData } from './table-data';
dayjs.extend(utc);

const REFETCH_INTERVAL = 30000;

export interface Props {
  alarm: ReducedAlarm;
  searchParams: string;
  children: (tableData: TableData) => ReactElement;
  dataVersion?: DataVersion;
}

export function RegularAlarmNeighboringEvents(props: Props) {
  const { alarm, searchParams, children, dataVersion } = props;
  const navigate = useNavigate();

  const onClickRow = useCallback(
    (alarm_: ReducedAlarm, event: React.MouseEvent | React.KeyboardEvent) => {
      const timestamp = alarm.timestamp;
      const date = dayjs.utc(timestamp);
      const partitionKey = date.format('YYYYMM');
      const url = appendVersionParam(
        `/alarms/${alarm_.id}?partitionKey=${partitionKey}`,
        dataVersion
      );

      const isNewTab = event.ctrlKey || event.metaKey;
      if (isNewTab) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        navigate(url);
      }
    },
    [alarm.timestamp, navigate, dataVersion]
  );

  const queryResult = useNeighboringAlarms(
    alarm.id,
    searchParams,
    REFETCH_INTERVAL,
    alarm.timestamp,
    dataVersion
  );

  return (
    <QueryResult queryResult={queryResult}>
      {(data) => children(getTableData(data, alarm, onClickRow))}
    </QueryResult>
  );
}

export default RegularAlarmNeighboringEvents;
